export const collection = 'view_handbook_pdf';
export const fileDirectory = 'pdf';
export const thumbnailPath = 'pdf_thumbnails';
